import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useRef } from 'react';
import {
  IoMdPerson as LoginIcon,
  IoMdSwitch as FiltersIcon,
  IoMdTrophy as TrophyIcon,
} from 'react-icons/io';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';

import { toggleNavigation } from '../../redux/actions';

const useStyles = createUseStyles({
  button: {
    height: 32,
    opacity: 1,
    transition: 'color 0.3s, opacity 0.3s',
    width: 32,
  },
  navigation: {
    composes: ['px24', 'py12', 'flex-columns', 'flex-between', 'flex-0'],
  },
});

const NAVIGATION_BUTTONS = [
  ['login', LoginIcon],
  ['trophies', TrophyIcon],
  ['filters', FiltersIcon],
];

const NavigationComponent = React.memo(({ opened }) => {
  const menu = useRef();
  const classes = useStyles();
  const dispatch = useDispatch();
  const appready = useSelector(_ => _.appready);

  const clickItemHandler = useCallback(
    id => {
      dispatch(toggleNavigation(id));
    },
    [dispatch]
  );

  return (
    <div ref={menu} className={classes.navigation}>
      {NAVIGATION_BUTTONS.map(([id, Icon]) => {
        const active = appready && opened === id;
        return (
          <button
            key={id}
            className={classnames(
              classes.button,
              { active },
              'smart-maps-menu-item'
            )}
            id={`demo-step-${id}`}
            type="button"
            onClick={() => clickItemHandler((!active && id) || null)}>
            <Icon size={24} />
          </button>
        );
      })}
    </div>
  );
});

NavigationComponent.defaultProps = {
  opened: null,
};

NavigationComponent.propTypes = {
  opened: PropTypes.string,
};

NavigationComponent.displayName = 'NavigationComponent';

export default NavigationComponent;
